/**
 * Created by user on 2018/3/18/018.
 */

import { minifyHTML } from '@jsdom-extra/html-util/minify';
import { normalizeHTML, INormalizeHTML } from '@jsdom-extra/html-util/normalize';

export { minifyHTML }
export { normalizeHTML, INormalizeHTML }
